export default __webpack_public_path__ + "static/media/puhelin-white.e12aaade.svg";